import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { PrivacyPolicyModal } from './PrivacyPolicyModal';
import { TermsModal } from './TermsModal';
export function Footer() {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  return <>
      <footer className="bg-slate-900 text-slate-400 py-12 px-4 border-t border-slate-800" data-id="element-19">
        <div className="max-w-4xl mx-auto" data-id="element-20">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center space-y-6" data-id="element-21">
            {/* Brand */}
            <div data-id="element-22">
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-23">
                Nail Business Blueprint
              </h3>
              <p className="text-sm text-slate-500" data-id="element-24">
                Your path to financial freedom as an independent nail tech
              </p>
            </div>

            {/* Legal Links */}
            <div className="flex items-center justify-center gap-6 text-sm" data-id="element-25">
              <button onClick={() => setShowPrivacyModal(true)} className="hover:text-rose-400 transition-colors duration-200 cursor-pointer" data-id="element-26">
                Privacy Policy
              </button>
              <span className="text-slate-700" data-id="element-27">|</span>
              <button onClick={() => setShowTermsModal(true)} className="hover:text-rose-400 transition-colors duration-200 cursor-pointer" data-id="element-28">
                Terms & Conditions
              </button>
            </div>

            {/* Disclaimers */}
            <div className="pt-6 border-t border-slate-800 space-y-4" data-id="element-29">
              {/* Facebook Disclaimer */}
              <p className="text-xs text-slate-600 leading-relaxed max-w-2xl mx-auto" data-id="element-30">
                This site is not a part of the Facebook website or Facebook Inc.
                Additionally, this site is NOT endorsed by Facebook in any way.
                FACEBOOK is a trademark of FACEBOOK, Inc.
              </p>

              {/* Earnings Disclaimer */}
              <p className="text-xs text-slate-600 leading-relaxed max-w-2xl mx-auto" data-id="element-31">
                We do not believe in 'get rich quick' programs. We believe in
                hard work, adding value, and building a real career. As
                stipulated by law, we cannot and do not make any guarantees
                about your ability to get results or earn any money with our
                tools or strategy.
              </p>
            </div>

            {/* Copyright */}
            <div className="pt-4" data-id="element-32">
              <p className="text-xs text-slate-500" data-id="element-33">
                © {new Date().getFullYear()} Nail Business Blueprint. All
                rights reserved.
              </p>
              <p className="text-xs text-slate-600 mt-2" data-id="element-34">
                Results may vary. This is an educational product.
              </p>
            </div>
          </motion.div>
        </div>
      </footer>

      <PrivacyPolicyModal isOpen={showPrivacyModal} onClose={() => setShowPrivacyModal(false)} data-id="element-35" />
      <TermsModal isOpen={showTermsModal} onClose={() => setShowTermsModal(false)} data-id="element-36" />
    </>;
}